import { permissionCheck } from "@/helpers/permission-check";
import { moduleCheck } from "@/helpers/module-check";

export default {
  stripeSubscriptionUiEnabled: state => state.stripeSubscriptionUiEnabled === true,
  selectedLocale: state => {
    return state.selectedLocale;
  },
  languages: state => {
    return state.languages;
  },
  sidebarMenu: state => {
    const sidebarMenu = JSON.parse(JSON.stringify(state.sidebarMenu));

    const hasAccess = item => {
      if (item.hasOwnProperty("module") && item.hasOwnProperty("permission")) {
        return moduleCheck(item.module) && permissionCheck(item.permission);
      } else if (item.hasOwnProperty("module")) {
        return moduleCheck(item.module);
      } else if (item.hasOwnProperty("permission")) {
        return permissionCheck(item.permission);
      }
      return true;
    };

    return Object.keys(state.sidebarMenu).reduce((root, key) => {
      return {
        ...root,
        [key]: sidebarMenu[key]
          .filter(item => hasAccess(item))
          .map(item => {
            if (item.hasOwnProperty("items")) {
              item.items = item.items.filter(item => hasAccess(item));
            }
            return item;
          })
          .filter(
            item =>
              !item.hasOwnProperty("items") ||
              (item.hasOwnProperty("items") && item.items.length)
          )
      };
    }, {});
  }
};
